import AssetList from 'components/assets/list'
import NotFoundError from 'errors/not-found-error'
import { AssetType } from 'lib/assets/asset'
import { ASSET_REGISTRY } from 'lib/assets/registry'
import { useRouter } from 'next/router'

const AssetTypeComponent = () => {
  const router = useRouter()
  const assetType =
    router.query.assetType && (String(router.query.assetType) as AssetType)
  if (!assetType) {
    return null // not resolved yet
  }

  const typeEntry = ASSET_REGISTRY[assetType]
  if (!typeEntry) {
    throw new NotFoundError()
  }

  return <AssetList assetType={assetType} />
}

export default AssetTypeComponent
